module.exports = __webpack_public_path__ + "static/media/njin.86ca7990.jpg";